// Client-side rarity metadata + Tailwind class helpers.
// Keeps parity with backend/rarity_system.py.

export const RARITY_META = {
  common:    { label: 'Common',    color: '#9CA3AF', glow: null,        cinematic: false },
  uncommon:  { label: 'Uncommon',  color: '#40916C', glow: '#95D5B2',   cinematic: false },
  rare:      { label: 'Rare',      color: '#5FA9E5', glow: '#8ECAE6',   cinematic: false },
  epic:      { label: 'Epic',      color: '#B27BC7', glow: '#D4A5DE',   cinematic: false },
  legendary: { label: 'Legendary', color: '#E9C46A', glow: '#F4D77B',   cinematic: true  },
  mythic:    { label: 'Mythic',    color: '#FF6EC7', glow: '#7DF9FF',   cinematic: true  },
};

// UI treatments used by DiscoveryReveal + BattleCard + Vault
export const RARITY_UI = {
  common: {
    ...RARITY_META.common,
    borderClass: 'ring-2 ring-white/10',
    borderStyle: {},
    cardClass: 'bg-gradient-to-b from-neutral-800/60 to-neutral-900/80 border border-white/10',
    cardStyle: {},
  },
  uncommon: {
    ...RARITY_META.uncommon,
    borderClass: 'ring-2',
    borderStyle: { '--tw-ring-color': '#40916C', boxShadow: '0 0 24px rgba(64,145,108,0.35)' },
    cardClass: 'bg-gradient-to-b from-emerald-900/50 to-neutral-900/80 border border-emerald-400/30',
    cardStyle: { boxShadow: '0 0 22px rgba(64,145,108,0.35)' },
  },
  rare: {
    ...RARITY_META.rare,
    borderClass: 'ring-2',
    borderStyle: { '--tw-ring-color': '#5FA9E5', boxShadow: '0 0 26px rgba(95,169,229,0.45)' },
    cardClass: 'bg-gradient-to-b from-sky-900/50 to-neutral-900/80 border border-sky-400/40',
    cardStyle: { boxShadow: '0 0 24px rgba(95,169,229,0.4)' },
  },
  epic: {
    ...RARITY_META.epic,
    borderClass: 'rarity-border-epic',
    borderStyle: {},
    cardClass: 'rarity-card-epic bg-gradient-to-b from-fuchsia-900/50 to-neutral-900/85 border',
    cardStyle: {},
  },
  legendary: {
    ...RARITY_META.legendary,
    borderClass: 'rarity-border-legendary',
    borderStyle: {},
    cardClass: 'rarity-card-legendary bg-gradient-to-b from-amber-900/60 to-neutral-900/85 border',
    cardStyle: {},
  },
  mythic: {
    ...RARITY_META.mythic,
    borderClass: 'rarity-border-mythic',
    borderStyle: {},
    cardClass: 'rarity-card-mythic bg-neutral-950 border',
    cardStyle: {},
  },
};
